import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, merge, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Asset } from './../../../../../../../_shared/model/asset.model';
import { Service } from './../../../../../../../_shared/model/service.model';
import { Subcontractor } from './../../../../../../../_shared/model/subcontractor.model';
import { TreatmentGUI } from './../../../../../../../_shared/model/treatment/treatmentGUI.model';
import { HelperService } from './../../../../../../../_shared/services/helper.service';
import { TreatmentState } from './../../../../../../../_shared/state/treatment/treatment.state';
import { CommonService } from './../../../../_services/common.service';

@Component({
    selector: 'trt-wid-m-details',
    templateUrl: './trt-wid-m-details.component.html',
    styles: [],
})
export class TrtWidMDetailsComponent implements OnInit {
    @Input()
    form: FormGroup;

    @Input()
    isSubmited = false;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onSelectFromCalendar: EventEmitter<any> = new EventEmitter();

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onAddEvent: EventEmitter<any> = new EventEmitter();

    public resRequestData: TreatmentGUI = new TreatmentGUI();

    public servicesForSubconstractor: Service[];

    public searching = false;
    // public treatmentDetailsForm: FormGroup;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public customTags: any = this.helper.loadCustomTags();
    public customerSearchFailed = false;
    // public isSubmited: boolean = false;
    public allSubcontractors: Subcontractor[];
    public assets: Asset[];

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public isInputVisible: any = {
        dateTime: true,
        recurringInput: true,
        generictitleInput: false,
        customerInput: true,
        servicesInput: true,
        servicesFixedInput: false,
        isAddCustomerButtonVisible: true,
    };

    private onDestroy$ = new Subject<void>();
    // private selectedContractor: Contractor = this.store.selectSnapshot(BaseState.activeContractor);

    constructor(
        private helper: HelperService,
        private commonRest: CommonService,
        private store: Store,
    ) {}

    ngOnInit() {
        combineLatest([
            this.store.select(TreatmentState.treatmentData).pipe(
                tap(resRequestData => (this.resRequestData = resRequestData)),
                takeUntil(this.onDestroy$),
            ),
        ])
            .pipe(takeUntil(this.onDestroy$))
            .subscribe();
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public onCustomerChange(customer): void {
        if (customer) {
            this.form.controls['emailNotify'].setValue(customer.sendMail);
            this.form.controls['smsNotify'].setValue(customer.sendSms);
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public equalsAnyById(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return;
        }
        return o1.id === o2.id;
    }

    public searchForCustomer = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => (this.searching = true)),
            switchMap(term =>
                this.commonRest.searchCustomers(term).pipe(
                    tap(result => {
                        if (result.length < 1) {
                            this.customerSearchFailed = true;
                        } else {
                            this.customerSearchFailed = false;
                        }
                    }),
                    catchError(() => {
                        return of([]);
                    }),
                ),
            ),
            tap(() => (this.searching = false)),
            merge(this.hideSearchingWhenUnsubscribed),
        );

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public hideSearchingWhenUnsubscribed = new Observable(() => () => (this.searching = false));

    public formatter(x: { name: string; surname: string; address: string; post: string; city: string }) {
        if (!x.name) {
            return;
        }
        let result: string = x.name + ' ' + x.surname;
        if (x.address) {
            result += ' ' + x.address;
        }
        if (x.post) {
            result += ' ' + x.post;
        }
        if (x.city) {
            result += ' ' + x.city;
        }

        return result;
    }

    // public createTreatment(): void {
    //     this.isSubmited = true;
    //     if (this.form.valid) {
    //         this.isSubmited = false;
    //         this.store.dispatch(new TreatmentActions.CreateNewTreatment()).subscribe(
    //             () => {
    //                 // this.treatmentDetailsForm.disable();
    //             },
    //             () => {
    //                 this.toast.error('Napaka pri kreiranju zravljenja.');
    //             },
    //         );
    //     }
    // }

    // private createForm(): void {
    //     // https://www.ngxs.io/plugins/form
    //     // if (!this.treatmentDetailsForm) {
    //     this.treatmentDetailsForm = this.fb.group({
    //         id: this.fb.control({ value: '' }),
    //         description: this.fb.control({ value: '' }, Validators.required),
    //         customer: this.fb.control({ value: '' }, Validators.required),
    //         smsNotify: this.fb.control({ value: '' }),
    //         emailNotify: this.fb.control({ value: '' }),
    //     });
    // }

    // private createForm(): void {
    //     //TODO uporabi https://www.ngxs.io/plugins/form
    //     if (!this.treatmentDetailsForm) {
    //         this.treatmentDetailsForm = this.fb.group({
    //             id: this.fb.control({ value: this.resRequestData.id, disabled: false }),
    //             description: this.fb.control(
    //                 { value: this.resRequestData.description, disabled: false },
    //                 Validators.required,
    //             ),

    //             customer: this.fb.control(
    //                 { value: this.resRequestData.customer, disabled: false },
    //                 Validators.required,
    //             ),
    //             smsNotify: this.fb.control({
    //                 value: _.get(this.resRequestData, 'customerForTerm.sendSms'),
    //                 disabled: false,
    //             }),
    //             emailNotify: this.fb.control({
    //                 value: _.get(this.resRequestData, 'customerForTerm.sendMail'),
    //                 disabled: false,
    //             }),
    //         });

    //         // this.treatmentDetailsForm.valueChanges
    //         //     .pipe(
    //         //         distinctUntilChanged(),
    //         //         debounceTime(500),
    //         //         takeUntil(this.onDestroy$),
    //         //     )
    //         //     .subscribe(() => {
    //         //         const treatment: TreatmentGUI = new TreatmentGUI().deserialize({
    //         //             // id: this.treatmentDetailsForm.value.id,
    //         //             description: this.treatmentDetailsForm.value.treatmentTitle,
    //         //             customer: this.treatmentDetailsForm.value.customer,
    //         //         });
    //         //         this.store.dispatch(new TreatmentActions.UpdateTreatment(treatment));
    //         //     });
    //     }
    // }
}
